// extracted by mini-css-extract-plugin
module.exports = {"SliderNavigation":"styles_SliderNavigation___ZeEm","button":"styles_button__pM0S7","isVisible":"styles_isVisible__aCjZj","icon":"styles_icon__z7N6a"};